import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {SelectItem} from 'primeng/api';

import {EventService} from '../../../../core';
import {AuthUser, TokenService,} from '../../../../core/auth';

import {UserGroup} from '../../../../core/models';
import {UserGroupService, UserService} from '../../../../core/services';
import {BreadcrumbService} from '../../../../breadcrumb.service';

@Component({
  selector: 'app-user-group-creation',
  templateUrl: './user-group-creation.page.html',
  styleUrls: ['./user-group-creation.page.scss']
})
export class UserGroupDCreationPage implements OnInit {
  @Input() userGroup: UserGroup;
  loading = false;
  saving = false;
  authUser: AuthUser = this.token.whoAmI();
  users: SelectItem[];

  constructor(
    private userGroupService: UserGroupService,
    private userService: UserService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private route: ActivatedRoute,
    private token: TokenService,
    private message: EventService
  ) {
    this.breadcrumbService.setItems([
      {label: 'admin', routerLink: ['/admin']},
      {label: 'user group', routerLink: ['/admin', 'group', 'list']},
      {label: 'new'},
    ]);
  }

  ngOnInit() {
    this.authUser = this.token.whoAmI();
    this.userGroup = {} as UserGroup;
    this.loadUsers();
  }

  setLoading(bool) {
    this.loading = bool;
  }


  backToList() {
    this.router.navigate(['/admin', 'group', 'list']);
  }

  saveUserGroup() {
    this.saving = true;
    this.updateUserGroup(this.userGroup);
  }

  updateUserGroup(userGroup: UserGroup) {
    this.saving = true;
    this.userGroupService.create(userGroup)
      .subscribe(
        (data) => {
          this.backToList();
          delete (this.saving);
        },
        (error) => {
          delete (this.saving);
        }
      );
  }

  loadUsers() {
    this.userService.getAll()
      .subscribe((data) => {
        this.users = [];
        data.forEach((user) => {
          this.users.push({label: user.email, value: user});
        });
        delete (this.loading);
      });
  }

  addUserToGroup(user) {
    if (!user) {
      return;
    }

    if (!this.userGroup.users) {
      this.userGroup.users = [];
    }

    let match = false;
    this.userGroup.users.forEach((existingUser) => {
      if (existingUser.id === user.id) {
        match = true;
      }
    });
    if (match) {
      this.message.warn(user.name + ' is already a member this group');
    }
    if (!match) {
      this.userGroup.users.push(user);
    }
  }

  delete(user) {
    const idx = this.userGroup.users.indexOf(user);
    if (idx !== -1) {
      return this.userGroup.users.splice(idx, 1); // The second parameter is the number of elements to remove.
    }
  }

}

